/* eslint-disable no-undef */
import { post } from '../helper/xhrAPI'
import { MenuManager } from './component/front/front-helpers/MenuManager'
import { createAlert, renderErrors } from '../helper/formSubmission'

document.addEventListener('DOMContentLoaded', e => {
  MenuManager()
  document.querySelector('#validateContact').addEventListener('click', e => {
    e.preventDefault()
    e.target.classList.add('is-loading')
    grecaptcha.ready(function () {
      grecaptcha.execute(`${e.target.getAttribute('data-sitekey')}`, { action: 'submit' }).then(function (token) {
        const data = new FormData(document.getElementById('contact-form'))
        data.append('g-recaptcha-response', token)
        post('/make-contact', data, response => {
          createAlert(response.code !== 200, response.message, '.contact-form', '#contact-form')
          if (response.code !== 200) {
            renderErrors(response.errors, '#contact-form', 'contact')
          }
          e.target.classList.remove('is-loading')
        })
      })
    })
  })
})
